import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

export default function CashlessInfoText({ keyValuePairs, textAlign }) {
  return (
    <Grid container spacing={2}>
      {keyValuePairs.map((ele) => {
        if (ele.key && ele.value) {
          return (
            <Grid
              item
              xs={ele.size ? ele.size : 4}
              style={{ textAlign: textAlign ? textAlign : 'center' }}
            >
              <Grid container spacing={1}>
                <Grid
                  item
                  xs={6}
                  style={{ textAlign: textAlign ? textAlign : 'center' }}
                >
                  <Typography variant="h5" component="h2">
                    {ele.key + ':'}
                  </Typography>
                </Grid>
                <Grid item xs={6} style={{ textAlign: 'left' }}>
                  {ele.value}
                </Grid>
              </Grid>
            </Grid>
          );
        } else {
          return null;
        }
      })}
    </Grid>
  );
}

const contractNameMapper = function (contractId, _) {
  switch (contractId) {
    case '10389':
      return 'Lab Test';
    case '10386':
      return 'Lab Tests Package';
    case '10390':
      return 'Medicine Pack';
    case '10846':
      return 'Online Consultation';
    case '13973':
      return 'Gold Subscription';
    case '10401':
      return 'Offline Consultation';
    default:
      return _;
  }
};

const corpNameMapper = function (corpName) {
  switch (corpName) {
    case '11185545':
      return 'Wells Fargo India Solutions Private Ltd';
    case '1027866':
      return 'Sodexo';
    // case '11209155':
    //   return 'Ryan';
    default:
      return 'Others';
  }
};

const serviceNameMapper = function (contractId) {
  switch (contractId) {
    case '10390':
      return 'Pharmacy';
    case '13973':
      return 'Consults';
    case '10846':
      return 'Consults';
    default:
      return 'Infiniti';
  }
};

export { contractNameMapper, corpNameMapper, serviceNameMapper };
